import { button } from '../../../DOM/button/BUTTON.js';
import DIALOG from '../../../DOM/dialog/DIALOG.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import { icon } from '../../../SVG/icon/ICON.js';
import { span } from '../../../DOM/span/SPAN.js';
import { SVGS } from '../../../SVG/SVGS.js';
import { text } from '../../../DOM/text/TEXT.js';
import BUTTONGROUP, { buttongroup } from '../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
// Model Structure
export const confirmAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['open']
]);
export const confirmData = makeDataStruct([
    ['caller', null],
    ['content', {}],
    ['header', {}],
    ['footer', {}],
    ['text', text()],
    ['onConfirm', () => { }],
    ['onCancel', () => { }]
]);
export const confirmModel = makeStruct([
    ['attributes', confirmAttr],
    ['data', confirmData]
]);
// Simplified Model
export function confirmEl(name, className, caller, header, footer, text, onConfirm, onCancel) {
    return {
        attributes: confirmAttr(name, className),
        data: confirmData(caller, undefined, header, footer, text, onConfirm, onCancel)
    };
}
/** A DIALOG with an embedded FORM that can be used to recieve input
    @description Creates a dialog and displays a text well and any included buttons
*/
export default class CONFIRM extends DIALOG {
    btnConfirm;
    btnCancel;
    constructor(node, model) {
        super(node, model);
        this.addClass('confirm');
        let buttonGroup = new BUTTONGROUP(this.content, buttongroup('confirm-buttons', 'vertical has-background'));
        this.btnConfirm = buttonGroup.addButton(button(span('Confirm'), 'btn-confirm', icon(SVGS.CHECKMARK), 'Confirm', 'confirm dialog-button'))
            .on('click', () => this.onConfirm());
        this.btnCancel = buttonGroup.addButton(button(span('Cancel'), 'btn-cancel', icon(SVGS.CLOSE), 'Cancel', 'cancel dialog-button'))
            .on('click', () => this.onCancel());
    }
    /** Function to call when 'confirmed' is selected */
    onConfirm() {
        this.data.onConfirm();
        this.hideDialog();
        return this;
    }
    /** Function to call when 'cancelled' is selected */
    onCancel() {
        this.data.onCancel();
        this.hideDialog();
        return this;
    }
}
